import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { MainPipeModule } from '../shared/pipes/mainpipe.module';
import { InvoicesComponent } from './invoices/invoices.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { PaymentHeaderComponent } from './payment-header/payment-header.component';
import { PaymentReviewComponent } from './payment-review/payment-review.component';

@NgModule({
  declarations: [
    InvoicesComponent,
    PaymentDetailsComponent,
    PaymentHeaderComponent,
    PaymentReviewComponent,
    PaymentConfirmationComponent,
  ],
  imports: [
    IconModule,
    CommonModule,
    NgbModule,
    RouterModule,
    NgbModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    FluDashboardBannerModule,
    BsDatepickerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountInvoiceComponent: {
          component: InvoicesComponent,
        },
        OpenInvoicePaymentReviewComponent: {
          component: PaymentReviewComponent,
        },
        AccountOpenInvoicePaymentComponent: {
          component: PaymentDetailsComponent,
        },
        OpenInvoicePaymentConfirmationComponent: {
          component: PaymentConfirmationComponent,
        },
      },
    } as CmsConfig),
    MainPipeModule,
  ],
})
export class CustomMakeAPaymentModule {}
